import './articleList.scss';
import { Link } from "react-router-dom";
import { useContext, useEffect, useState } from 'react';
import { ArticleContext } from '../../components/context';
import { useLocation } from 'react-router-dom'
import { translateText } from './../article/article'
import SoldOutIcon from './stampsold01.svg'
import useCart from '../../hooks/useCart';
import { PHP_URL } from '../../config/env';

export default function ArticleList({ homepageData = {} }) {
  const location = useLocation();
  const { articleData, setArticleData } = useContext(ArticleContext);
  const [itemCounts, setItemCounts] = useState(null);
  const [loading, setLoading] = useState(true);
  const showNewArticle = homepageData.showNewArticle
  useEffect(() => {
    const fetchCounts = async () => {
      try {
        const response = await fetch(`${PHP_URL}/count.php?x=all`);
        const counts = await response.json();
        setItemCounts(counts);
        setLoading(false);
      } catch (error) {
        console.error("Failed to fetch item counts:", error);
      }
    };

    fetchCounts();
  }, []);

  useEffect(() => {
    if (itemCounts && articleData) {
      const updatedArticleData = articleData.map(article => {

        const countData = itemCounts.find(c => c.ProductId === `${article.id.toString()}-${article.attributes.size || ''}-${article.attributes.option || 0}`);
        if (countData) {
          return {
            ...article,
            attributes: {
              ...article.attributes,
              currentlySold: parseInt(countData.anzahl, 10),
              soldOutLogo: article.attributes.soldOutLogo ? true : article.attributes.anzahl && article.attributes.anzahl > 0 ? parseInt(countData.anzahl, 10) + 1 > article.attributes.anzahl : false,
            },
          };
        }
        return article;
      });
      // This check prevents an infinite loop
      if (JSON.stringify(updatedArticleData) !== JSON.stringify(articleData)) {
        setArticleData(updatedArticleData);
      }
    }
  }, [itemCounts, articleData, setArticleData]);

  const search = location.pathname.replace('/shop/', '');
  const titleClass = search === 'BAK' ? 'BAK title' : 'title';
  const filteredByHomepageFlag = showNewArticle === true
    ? articleData.filter(article => article.attributes.hideIfShowNewArticleIsFalse === true)
    : showNewArticle === false
      ? articleData.filter(article => article.attributes.hideIfShowNewArticleIsFalse !== true)
      : articleData;
  const current = search === 'Alles'
    ? filteredByHomepageFlag
    : search === 'Tickets'
      ? filteredByHomepageFlag.filter(x => x.attributes.type === 'Tickets' || x.attributes.type === 'E-Tickets')
      : filteredByHomepageFlag.filter(x => x.attributes.type === search);
  current.sort((a, b) => {
    return a.attributes.order - b.attributes.order;
  });
  return (
    <div className='articleListBox'>
      <div className='content'>
        <div className="CartContainer">
          {current.map(item => (
            <ArticleListItem key={item.id} loading={loading} item={item} titleClass={titleClass} />
          ))}
        </div>
      </div>
    </div>
  );
}

function ArticleListItem(props) {
  const { item, titleClass, loading } = props
  const cart = useCart()

  return (
    <div className="articleListItem">
      <div className="image-box">
        {item?.attributes?.bilder?.data?.length > 0 &&
          <img alt={item.attributes.name + 'image'} src={item.attributes.bilder.data[0]?.attributes?.formats?.small?.url} />
        }
        {item.attributes.soldOutLogo && <img className='soldOut' src={SoldOutIcon} alt="Sold out banner" />}
      </div>
      <div className="about">
        <h1 className={titleClass}><Link to={"/shop/artikel/" + item.id}>{item.attributes.name}</Link></h1>
        <h3 className="subtitle">{translateText(item.attributes.subType1)}{translateText(item.attributes.subType2) ? ` | ${translateText(item.attributes.subType2)}` : ''}{translateText(item.attributes.subType3) ? ` | ${translateText(item.attributes.subType3)}` : ''}</h3>
      </div>
      <div className="prices">
        <div className="amount">{item.attributes.preis.toFixed(2)}&nbsp;€</div>
      </div>
      {(item.attributes.type === "Tickets" || item.attributes.type === "E-Tickets") && (
        <ArticleWarenkorbControl loading={loading} item={item} cart={cart} />
      )}
    </div>
  )
}

function ArticleWarenkorbControl(props) {
  const { item, cart, loading } = props
  const amount = cart.getAmount(item)

  const addToCart = () => {
    if (item.attributes.anzahl && item.attributes.currentlySold + amount > item.attributes.anzahl) {
      return;
    }
    cart.add({
      ...item.attributes,
      id: item.id,
      amount: 1,
    })
  }

  const increaseAmount = () => {
    if (item.attributes.anzahl && item.attributes.currentlySold + amount >= item.attributes.anzahl) {
      return;
    }
    cart.setAmount({ id: item.id }, amount + 1)
  }

  const decreaseAmount = () => {
    cart.setAmount({ id: item.id }, amount - 1)
  }
  const buttonText = item.attributes.soldOutLogo ? 'Ausverkauft' : !loading ? 'In den Warenkorb' : 'Bitte warten...';
  if (amount === 0) {
    return (
      <div className='orderControl'>
        <button disabled={loading || item.attributes.soldOutLogo} className={item.attributes.type + ' button'} onClick={addToCart}>{buttonText}</button>
      </div>
    )
  } else {
    return (
      <div className='orderControl'>
        <div className="counter">
          <div onClick={decreaseAmount} className="btn">-</div>
          <div className="count">{amount}</div>
          <div onClick={increaseAmount} className="btn">+</div>
        </div>
      </div>
    )
  }
}
